
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppBar from "../../common/AppBar";

import {exportTempltRulesCSV,fetchAllProcedureTemplateRules} from "../../redux/procedureTemplateRulesSlice";
import "./ProcedureTemplateRules.css";
import Snackbar from "../../common/Snackbar";
import AppTable from "../../common/AppTable/AppTable";
import Loader from "../../common/Loader";
import RenderHtml from "../../common/AppSpecificConpnents/PartsTable/RenderHtml";

const ProcedureTemplateRules = () => {
  const columnNames = [
  { headName: "Document Type", field: "procedure_type", sort: true, filter: true, width:"25%" },
  { headName: "Documents To Make Available As Template", field: "procedure_to_make_available_as_template", filter: true,width:"60%"  },
  { headName: "Action", field: "action", isAction:true,}];
  const tableContainerRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false)

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const { rules, pagination } = useSelector((state) => state.procedureTemplateRule);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(()=>{
    dispatch(fetchAllProcedureTemplateRules({searchQuery}))
  },[dispatch, searchQuery])


  const exportCSV = async () => {
    setShowLoader(true)
    dispatch(exportTempltRulesCSV()).then((res) => {
      setShowLoader(false)
      if (exportTempltRulesCSV.fulfilled.match(res)) {
        showSnackbar("Document Template Rules export completed!", "success");
      } else {
        showSnackbar(
          "Error exporting Document Template Rules CSV: " + res.payload,
          "error"
        );
      }
    });
  };

    const paginationLeftContent = <button
            className="appbar-buttonpopup"
            style={{
              border: "1px solid #0D6EFD",
              backgroundColor: "#ffffff",
              color: "#0D6EFD",
              height: "40px",
              fontSize: "13px",
              marginLeft: "-1px",
              marginTop: "10px",
            }}
            onClick={exportCSV}
          >
            Export CSV
          </button>
  return (
    <div>
      <AppBar
        title="New Document Template Rules"
        showTablesDropdown={false}
        showBlackTitle={true}
        buttons={[]}
      />
      <AppTable 
        ref={tableContainerRef}
        columnsData={columnNames}
        showSearchInput={true}
        paginate={true}
        pagination={{
          limit: [limit, setLimit],
          offset: [offset, setOffset],
          pagination,
          paginationPosition:{
            position:"right",
            leftContent:paginationLeftContent
          }
        }}
        extrapadding="0px"
        onFilterSortHandler={setSearchQuery}
      >
        {
          structuredClone(rules).map((row, index) => {
            let defText = <span style={{ color: "#007bff" }}>(Default)</span>;
         

            // Note: If you changed here please make sure to change in csv export logic
            return (
              <tr key={index}>
                <td style={{ textAlign: "left" }}>{row.name}</td>
                <td>
                  {row.is_blank_template_permitted !== null && (
                    <div>
                      Blank {row?.is_blank_template_permitted === true && defText}
                    </div>
                  )}
                  {row?.parts?.map((part) => (
                    <div key={part.part_number}>
                      {part.part_number} - <RenderHtml content={part.description}/>{" "}
                      {part.is_default_template && defText}
                    </div>
                  ))}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    padding: 0,
                  }}
                >
                  <div className="app-action-btns" style={{ marginTop: "5px" }}>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        navigate("/add-procedure-template-rule", {
                          state: { editMode: true, rule: row },
                        });

                        setTimeout(() => {
                          window.scrollTo({ top: 0, behavior: "smooth" }); // 'smooth' for animation
                        }, 1000);
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.4192 5.57534L9.93101 2.12329L11.0801 0.972603C11.3947 0.657534 11.7811 0.5 12.2394 0.5C12.6976 0.5 13.084 0.657534 13.3987 0.972603L14.5477 2.12329C14.8623 2.43836 15.0265 2.81849 15.0402 3.2637C15.0538 3.7089 14.9034 4.08904 14.5888 4.40411L13.4192 5.57534ZM12.2291 6.78767L3.52919 15.5H0V12.0068L8.74093 3.29452L12.2291 6.78767Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                    {/* <button
                            className="delete-row"
                            onClick={() => {
                              if (row.parts.length > 0) {
                                handleDelete(row.parts[0].procedure_template_id);
                              }
                            }}
                          >
                            🗑
                          </button> */}
                  </div>
                </td>
              </tr>
            );
          })
        }
      </AppTable>
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}
      {
          showLoader && <Loader/>
      }
    </div>
  );
};

export default ProcedureTemplateRules;
